"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "appignano-del-tronto": {
    "de3b7888": [{
      "hkey": "0e5031bd",
      "slug": "appignano-del-tronto",
      "name": "Appignano del Tronto",
      "primary": true,
      "skipSearch": false
    }],
    "capodipiano": [{
      "hkey": "0e5031bd",
      "slug": "appignano-del-tronto",
      "name": "Appignano del Tronto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "628af265": [{
      "hkey": "0e5031bd",
      "slug": "appignano-del-tronto",
      "name": "Appignano del Tronto",
      "primary": true,
      "skipSearch": false
    }],
    "castellano": [{
      "hkey": "0e5031bd",
      "slug": "appignano-del-tronto",
      "name": "Appignano del Tronto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "b1f2e8ce": [{
      "hkey": "0e5031bd",
      "slug": "appignano-del-tronto",
      "name": "Appignano del Tronto",
      "primary": true,
      "skipSearch": false
    }],
    "cepparano": [{
      "hkey": "0e5031bd",
      "slug": "appignano-del-tronto",
      "name": "Appignano del Tronto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "5f8a06b6": [{
      "hkey": "0e5031bd",
      "slug": "appignano-del-tronto",
      "name": "Appignano del Tronto",
      "primary": true,
      "skipSearch": false
    }],
    "cerreto": [{
      "hkey": "0e5031bd",
      "slug": "appignano-del-tronto",
      "name": "Appignano del Tronto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "289d8ce4": [{
      "hkey": "0e5031bd",
      "slug": "appignano-del-tronto",
      "name": "Appignano del Tronto",
      "primary": true,
      "skipSearch": false
    }],
    "gimigliano": [{
      "hkey": "0e5031bd",
      "slug": "appignano-del-tronto",
      "name": "Appignano del Tronto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "c5a0ba78": [{
      "hkey": "0e5031bd",
      "slug": "appignano-del-tronto",
      "name": "Appignano del Tronto",
      "primary": true,
      "skipSearch": false
    }],
    "monsampietro": [{
      "hkey": "0e5031bd",
      "slug": "appignano-del-tronto",
      "name": "Appignano del Tronto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "6aac3e2a": [{
      "hkey": "0e5031bd",
      "slug": "appignano-del-tronto",
      "name": "Appignano del Tronto",
      "primary": true,
      "skipSearch": false
    }],
    "olibra": [{
      "hkey": "0e5031bd",
      "slug": "appignano-del-tronto",
      "name": "Appignano del Tronto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "8007d5e7": [{
      "hkey": "0e5031bd",
      "slug": "appignano-del-tronto",
      "name": "Appignano del Tronto",
      "primary": true,
      "skipSearch": false
    }],
    "portella": [{
      "hkey": "0e5031bd",
      "slug": "appignano-del-tronto",
      "name": "Appignano del Tronto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "efcf3936": [{
      "hkey": "0e5031bd",
      "slug": "appignano-del-tronto",
      "name": "Appignano del Tronto",
      "primary": true,
      "skipSearch": false
    }],
    "vallorano": [{
      "hkey": "0e5031bd",
      "slug": "appignano-del-tronto",
      "name": "Appignano del Tronto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;